<template>
  <div class="row g-2 mb-3">
    <div class="col-12">
      <div class="card no-hover pt-2 bg-blurry overflow-hidden">
        <div class="table-responsive-md">
          <table class="table align-middle position-relative blur mb-0" itemscope itemtype="https://schema.org/Table">
            <thead>
            <tr>
              <th scope="col" class="small text-uppercase opacity-75 fw-normal pt-0">{{ isDutch ? 'Naam' : 'Name'}}</th>
              <th class="small text-uppercase opacity-75 fw-normal pt-0">{{ isDutch ? 'Luchthaven' : 'Airport'}}</th>
              <th class="small text-uppercase opacity-75 fw-normal pt-0">{{ isDutch ? 'Locatie' : 'Location'}}</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="lounge in lounges" :key="lounge.slug"
                  @click="openLink((isDutch ? '/nl/lounges/' : '/lounges/') + lounge.slug)">
                <th>
                  <NuxtLink
                      class="inherit"
                      :title="lounge.name + ' ' + lounge.airport.name_en"
                      :to="{ name: isDutch ? 'nl-lounges-slug' : 'lounges-slug', params: { slug: lounge.slug } }">
                    {{ lounge.name }}
                  </NuxtLink>
                </th>
                <th><span class="d-block d-md-inline">{{ isDutch ? lounge.airport.city.name_nl : lounge.airport.city.name }}</span> <span class="badge rounded-pill small border ms-md-1 mb-0 bg-blurry">{{ lounge.airport.iata }}</span></th>
                <th>
                  {{ lounge.airside ? 'Airside' : 'Landside' }}
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

interface Lounge {
  name: string,
  airport: object,
  airside: boolean,
  slug: string
}

interface Props {
  lounges: Lounge[],
}

const isDutch = inject('isDutch');
const props = defineProps<Props>();

function openLink(url: string | URL | undefined) {
  setTimeout(() => {
    window.open(url, '_self');
  })
}

</script>